'use client';
import React from 'react';
import { Drawer } from '@repo/ui/src/modules/UI/components/Drawer';
import { DrawerHeader, ModalID, useModal } from '@repo/ui/src/modules/UI';
import ShopableList from '@components/ShopableList';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';

const ShoppableIngredientsDrawer = () => {
  const { data } = useModal(ModalID.shoppableIngredients);
  const { t } = useTranslation();

  return (
    <Drawer id={ModalID.shoppableIngredients}>
      <div className="tw-max-w-[500px]">
        <DrawerHeader
          title={t('recipeContent.shoppableRecipeTitle', undefined, {
            default: 'Shop this Recipe',
          })}
        />
        <ShopableList data={data} />
      </div>
    </Drawer>
  );
};

export default ShoppableIngredientsDrawer;
